<template>
  <div v-if="null !== criteria" class="filter-bar">
    <FilterLabel
      v-if="acceptedLabels(criteria.labels).length > 0"
      :labels="acceptedLabels(criteria.labels)"
    />
    <FilterPriceControl />
    <FilterSpecifications
      v-for="specification in criteria.specifications"
      :key="specification.id"
      :specification="specification"
    />
    <Compilations
      v-if="null !== compilations && compilations.categories.length > 0"
      :compilations="compilations"
    />
  </div>
</template>

<script setup>
import FilterLabel from "~/modules/productCatalog/ui/components/filter/bar/FilterLabel.vue";
import FilterPriceControl from "~/modules/productCatalog/ui/components/filter/bar/FilterPriceControl.vue";
import FilterSpecifications from "~/modules/productCatalog/ui/components/filter/bar/FilterSpecifications.vue";
import { useCriteriaStore } from "~/store/criteriaStore";
import { useCategoriesStore } from "~/store/categoriesStore";
import Compilations from "~/modules/productCatalog/ui/components/filter/bar/Compilations.vue";

const categoriesStore = useCategoriesStore();
const { getCompilationCategories } = storeToRefs(categoriesStore);

const criteriaStore = useCriteriaStore();
const { getCriteria: criteria } = storeToRefs(criteriaStore);

const acceptedLabels = (labels) =>
  labels.filter(({ label }) =>
    ["promotion", "novelty", "bestSeller"].includes(label),
  );

const route = useRoute();
const compilations = ref(null);

watch(
  () => route.params.categorySlug,
  () => {
    if (route.params.categorySlug) {
      compilations.value = getCompilationCategories.value(
        route.params.categorySlug,
      );
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.filter-bar {
  width: 100%;

  @include flex-container(column, flex-start);

  border: 1px solid var(--color-sky-light);
  border-radius: 16px;

  background-color: white;

  padding-block: 16px;

  @include bigMobile {
    gap: 16px;

    border: none;

    padding: 0 16px;
  }
}
</style>
